import { getRuntimeConfig } from "./runtime-config";

const rc = getRuntimeConfig();
const apiBaseUrl = window.location.hostname == "localhost" ? `${rc.apiBaseUrl}` : window.location.origin;
const instId = `${rc.institutionUniversalId}`;
const awsBucketName = `${rc.awsBucketName}`;
const smbBucketName = `${rc.smbBucketName}`;
export const GlobalVariables = {
  API_BASE_URL: apiBaseUrl,
  INSTITUTION_UNIVERSAL_ID: instId,
  TOAST_TIMEOUT: 7500,
  MAIN_TITLE: "EFM",
  AWS_BUCKET_NAME: awsBucketName,
  SMB_BUCKET_NAME: smbBucketName,
  USER_PASSWORD_MIN_LENGTH: 20,
};
export const GlobalConstants = {
  TIMEZONE: "Asia/Calcutta",
  TIME_FORMAT: "DD-MM-YYYY HH:mm:ss",
  CALENDAR_MAX_DATE_DAYS: 0,
  CALENDAR_MIN_DATE_MONTHS: 3,
  JHADOMAIN: ["jackhenry.com", "jhacorp.com"],
  OTPTimerValue: 180,
  SESSION_REFRESH_BEFORE_EXPIRY_MS: 5 * 60 * 1000,
  /** Idle logout window; user input resets it. API traffic must not. */
  MAX_INACTIVITY_DURATION_MS: 15 * 60 * 1000,
};
export const UserTypes = {
  participant: "participant",
  businessadmin: "businessadmin",
  enterpriseadmin: "enterpriseadmin",
};
